//@flow
import * as React from 'react';
import type {children, id, onClick} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import './NHeading3.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children,
  onClick?: onClick
};

const NHeading3 = (props: Props) => {
  return (
    <div id={props.id} onClick={props.onClick} className={baseClass("NHeading3", props.addClasses)}>{props.children}</div>
  );
};

export default NHeading3;